// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bhb_a bhr_ea bhr_a","LoadingSwitch__init":"bhb_b bhr_a bhr_w bhr_j bhr_ul bhr_um bhr_fm"};